export * from "./SocialProofCard";
export * from "./SocialProofCard.config";
